<template>
    <el-breadcrumb class="breadcrumbs" separator="/">
        <el-breadcrumb-item
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
            :to="breadcrumb.route || null"
            @click="toPage(breadcrumb)"
            >{{ breadcrumb.title || breadcrumb }}</el-breadcrumb-item
        >
    </el-breadcrumb>
</template>

<script>
export default {
    name: 'TheBreadcrumbs',
    computed: {
        breadcrumbs() {
            return this.$route.meta?.breadcrumbs ?? [this.$route.meta?.title];
        }
    },
    methods: {
        toPage({back,route}) {
            if(back){
                this.$router.go(back)
            }else{
                this.$router.push(route)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
    padding-bottom: 6px;
    padding-left: 7px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 400;
    &::v-deep {
        .el-breadcrumb__inner.is-link,
        .el-breadcrumb__inner a {
            color: #b8b6b6;
            font-weight: 400;
        }
        .el-breadcrumb__inner {
            color: #b8b6b6;
        }
        .el-breadcrumb__item:last-of-type .el-breadcrumb__inner {
            color: #333333;
        }
    }
}
</style>
